export const INTEREST_API_PATH = 'v2/interests'
export const INTEREST_PAGE_SIZE = 50

export const INTEREST_STATUS = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  ARCHIVED: 'archived',
} as const

export const INTEREST_STATUS_LABEL = {
  [INTEREST_STATUS.ACTIVE]: 'Active',
  [INTEREST_STATUS.DRAFT]: 'Draft',
  [INTEREST_STATUS.ARCHIVED]: 'Archived',
} as const

export const INTEREST_ROUTE = {
  LIST: '/customers/preferences/interests',
  CREATE: '/customers/preferences/interests/new',
  EDIT: '/customers/preferences/interests/:interestId/edit',
  ORDER: '/customers/preferences/interests/order',
} as const

export const INTEREST_CACHE_TAG = {
  LIST: 'LIST',
} as const

export const INTEREST_MESSAGE = {
  CREATED: 'Shopping interest created',
  UPDATED: 'Shopping interest updated',
  ARCHIVED: 'Shopping interest archived',
  RESTORED: 'Shopping interest restored to draft',
  ORDERED: 'Shopping interest order saved',
  LOAD_ERROR: 'Unable to load shopping interests.',
  CATEGORY_LOAD_ERROR: 'Unable to load product categories.',
  ARCHIVED_EDIT_ERROR:
    'Restore this archived interest before editing its details.',
  DUPLICATE_ORDER_ERROR:
    'Each shopping interest must appear exactly once in the saved order.',
  GENERIC_ERROR: 'Unable to complete the request. Please try again.',
} as const

export const INTEREST_ARCHIVE_CONFIRM = {
  MODAL: 'confirmArchiveModal',
  MESSAGE: 'This interest will be archived until it is restored.',
  CONFIRM_TEXT: 'Archive',
} as const

/**
 * Builds the archive confirmation modal title for a Shopping Interest.
 */
export const getArchiveInterestConfirmTitle = (interestName: string): string =>
  `Archive "${interestName}"?`
